<div class="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8 p-container">
  <div *ngIf="showAssessment" class="container mx-auto max-w-[1000px]">
    <!-- Header -->
    <div class="text-center mb-10 overflow-hidden">
      <h1 class="text-3xl font-extrabold text-primary sm:text-4xl">Pre-Assessment Questions</h1>
      <p class="mt-4 text-lg text-foreground-secondary">
        Please answer the following questions to help us understand your needs better.
      </p>
    </div>

    <!-- Loading State -->
    <div *ngIf="isLoading" class="flex flex-col items-center justify-center py-20">
      <p-progress-spinner ariaLabel="loading"></p-progress-spinner>
      <p class="mt-4 text-gray-500 animate-pulse">Loading questions...</p>
    </div>

    <!-- Questionnaire Content -->
    <form *ngIf="!isLoading && form" [formGroup]="form" (ngSubmit)="onSubmit()" class="space-y-8">
      <div *ngFor="let question of rootQuestions">
        <app-dynamic-question
          [question]="question"
          [form]="form"
          [allQuestions]="questions"
          [level]="0"
          [patientDetails]="patientDetails"
        ></app-dynamic-question>
      </div>

      <!-- Static Health Report (Always Shown) -->
      <div class="bg-card p-6 rounded-2xl shadow-sm border border-gray-100 mt-8">
        <h3 class="text-lg font-semibold text-foreground mb-2">Health Documents</h3>
        <p class="text-sm text-gray-500 mb-4">
          Upload your latest health report if available (Optional)
        </p>

        <div
          class="border-2 border-dashed border-gray-200 rounded-2xl p-8 flex flex-col items-center justify-center gap-4 hover:border-blue-400 transition-all bg-gray-50 group"
        >
          <div
            class="w-16 h-16 bg-blue-50 text-blue-600 rounded-full flex items-center justify-center text-2xl group-hover:scale-110 transition-transform"
          >
            <i class="pi pi-cloud-upload"></i>
          </div>
          <div class="text-center">
            <p-fileupload
              mode="basic"
              name="health_report"
              [auto]="true"
              [multiple]="true"
              (onSelect)="onHealthReportUpload($event)"
              chooseLabel="Choose Health Report"
              styleClass="p-button-primary shadow-md"
            ></p-fileupload>
            <p class="text-xs text-gray-500 mt-2 font-medium">Accepts PDF and Images</p>
          </div>
          <div
            *ngIf="form.get('health_report')?.value"
            class="w-full mt-4 p-3 bg-green-50 border border-green-100 rounded-xl flex items-center justify-between"
          >
            <div class="flex items-center gap-2">
              <i class="pi pi-check-circle text-green-600"></i>
              <span class="text-xs font-semibold text-green-700 truncate max-w-[200px]"
                >Report Uploaded Successully</span
              >
            </div>
            <a
              [href]="form.get('health_report')?.value"
              target="_blank"
              class="text-xs text-blue-600 font-bold hover:underline cursor-pointer"
              >View Report</a
            >
          </div>
        </div>
      </div>

      <!-- Footer Actions -->
      <div class="flex justify-center mt-12 pb-20">
        <p-button
          type="submit"
          [label]="isSubmitting ? 'Submitting...' : 'Submit Assessment'"
          [disabled]="!isFormValid || isSubmitting"
          styleClass="w-full sm:w-64 p-button-lg rounded-full shadow-lg transform hover:scale-105 transition-all"
        >
        </p-button>
      </div>
    </form>
  </div>

  <!-- show one dsiclaimer that after appoinment submit contin one button that show chekck your assement  score   -->
  <div class="w-full max-w-2xl mx-auto mt-10" *ngIf="showScore">
    <div
      class="bg-card border border-gray-200 rounded-2xl shadow-md p-6 flex flex-col items-center text-center gap-4"
    >
      <!-- Icon -->
      <div
        class="w-16 h-16 flex items-center justify-center rounded-full bg-green-100 text-green-600 text-3xl"
      >
        <i class="pi pi-check-circle"></i>
      </div>

      <!-- Title -->
      <h2 class="text-2xl font-semibold text-gray-800">Pre-Assessment Submitted Successfully</h2>

      <!-- Description -->
      <p class="text-gray-500 max-w-md">
        Great job! 🎉 Your responses have been recorded successfully. Based on your answers, we have
        prepared your personalized health insights.
      </p>

      <!-- Highlight Info Box -->
      <div
        class="w-full bg-green-50 border border-green-200 rounded-xl p-4 flex items-center gap-3 mt-2"
      >
        <i class="pi pi-chart-line text-green-600 text-xl"></i>
        <p class="text-sm text-green-700 font-medium">
          Your health score and recommendations are ready to view.
        </p>
      </div>

      <!-- Action Button -->
      <div class="mt-4 w-full">
        <p-button
          label="View Assessment Score"
          icon="pi pi-arrow-right"
          iconPos="right"
          (click)="goToScore()"
          styleClass="w-full p-button-primary rounded-xl py-3 text-lg shadow-md"
        >
        </p-button>
      </div>
    </div>
  </div>
  <!-- assesment score -->
  <!-- <div class="mx-auto max-w-[1000px]">
    <patient-pre-score
      *ngIf="showScore"
      (proceedClicked)="handleProceed($event)"
      [scoreDataInput]="scoreDataInput"
    ></patient-pre-score>
  </div> -->
  <!-- payment summury  -->
  <div>
    <patient-payment-summury
      *ngIf="showSummury"
      [summaryData]="AppointmentDetails"
    ></patient-payment-summury>
  </div>
</div>
